<app-modal-refactor
  [size]="'lg'"
  [showImage]="true"
  [image]="'assets/images/check-pink-circle.svg'"
  [backGroundColor]="'am-blue-premium'"
  [imageClose]="'assets/images/Close_Modal_visa.png'"
  [showImageClose]="true"
  [classNameContainer]="'havana-block-container'"
>
  <div body class="havana-body">
    <h2 class="fs-42px lh-52px fw-medium-x text-white">
      {{ 'havanaBlock.title' | translate }}
    </h2>
    <p class="fs-24px lh-34px fw-regular text-white description">
      {{ 'havanaBlock.message' | translate }}
    </p>
  </div>
</app-modal-refactor>
